'use client'
import { Auth } from '@/domains/Account/modules/Auth'
import { isScreenList } from '@/store/Auth'
import { notFound, useParams } from 'next/navigation'
import { useMemo } from 'react'

const AuthPage = () => {
  const { tab } = useParams<{ tab: string }>()

  const screen = useMemo(() => {
    if (tab != null) {
      const preparedTab = tab.toUpperCase()
      if (isScreenList(preparedTab)) {
        return preparedTab
      }
    }
  }, [tab])

  if (screen == null) {
    notFound()
  }

  return <Auth screen={screen} />
}

export default AuthPage
